import {
  Col,
  message,
  Row,
  Select
} from "antd";
import { useEffect, useState } from "react";


const PowerBIDashboardViewer = () => {
  const [dashboards, setDashboards] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const fetchDashboards = async () => {
    const data = [];
    const dashboard1 = {
      id: "1",
      rol: 'finance',
      title: process.env.REACT_APP_DASHBOARD_TITLE,
      url: process.env.REACT_APP_DASHBOARD_URL
    }
    data.push(dashboard1);
    setDashboards(data);
    setSelectedId("1");
  };

  useEffect(() => {
    const loadUserAndDashboards = async () => {
      try {
        await fetchDashboards();
      } catch (error) {
        console.error("Error fetching user or dashboards:", error);
        message.error("Failed to load dashboards.");
      }
    };

    loadUserAndDashboards();
  }, []);


  const selectedDashboard = dashboards.find((d) => d.id === selectedId);

  return (
    <div
      style={{
        height: "100vh",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Top bar: botones y select */}
      <div style={{ padding: 16, flex: "0 0 auto" }}>
        <Row gutter={16}>
          <Col>
            <Select
              placeholder="Select a dashboard"
              style={{ width: 300 }}
              value={selectedId || undefined}
              onChange={setSelectedId}
              options={dashboards.map((d) => ({
                label: d.title,
                value: d.id,
              }))}
            />
          </Col>
        </Row>
      </div>

      {/* Dashboard viewer */}
      {selectedDashboard && (
        <div style={{ position: "relative", flex: 1 }}>
          <iframe
            src={selectedDashboard.url}
            title={selectedDashboard.title}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "94%",
              border: "none",
            }}
            allowFullScreen
          />
        </div>
      )}


    </div>
  );
};

export default PowerBIDashboardViewer;
